export default __webpack_public_path__ + "static/media/img7.3b7d2824.png";